export const environment = {
  production: true,
  cryptoAES: "xyXTvZQTcQRt5AN",
  api: "https://cr.tavuel.com/api",
  firebase: {
    apiKey: "AIzaSyCBVV-BADea7PB_33t1dzx-h3KIpZsdwk0",
    authDomain: "tavuel506.firebaseapp.com",
    databaseURL: "https://tavuel506.firebaseio.com",
    projectId: "tavuel506",
    storageBucket: "tavuel506.appspot.com",
    messagingSenderId: "536950237048",
    appId: "1:536950237048:web:3c9094800aa0bab8",
    vapidKey: 'BOYLZxNFZE2AKVxp6QBfFbSIYz1bj_0PwC2ESf31H9tgd1JV5Qdy85YDJVz3b8fsHopfG1i02k6S17e_Eka9a3Y',
  },
  apiEB: "https://cr.tavuel.com/eb",
  p12Upload: "https://hacienda-dev.cr.tavuel.com/api.php",
  placesApi: "https://cr.tavuel.com/places",
  bucket_place: "",
  billing_profile: "https://billing-profile.web.app",
};
